export default __webpack_public_path__ + "static/media/accountBannerMB.bf528951.png";